export default {
    // 构建初始table表数据
    tableData: [
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            AQty: "",//可用库存
            Qty: '',//数量
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            AQty: "",//可用库存
            Qty: '',//数量
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            AQty: "",//可用库存
            Qty: '',//数量
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            AQty: "",//可用库存
            Qty: '',//数量
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            AQty: "",//可用库存
            Qty: '',//数量
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            Qty: '',//数量
            AQty: "",//可用库存
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            Qty: '',//数量
            AQty: "",//可用库存
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            Qty: '',//数量
            AQty: "",//可用库存
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },
        {
            PtypeId: '',//商品Id
            AtypeId: "",
            FullName: '',//商品名称
            BaseCode: "",
            Qty: '',//数量
            AQty: "",//可用库存
            ShowPrice: '',//单价
            Total: '',//金额
            Memo: '',//备注
            Discount: '',//折扣
            DiscountPrice: '',//折后单价
            DiscountTotal: '',//折后金额
            Tax: '',//税率
            TaxPrice: '',//产品含税单价
            WithTaxTotal: '',//产品含税金额
            TaxTotal: '',//税额
            ChargePrice: '',//费用单价
            ChargeTotal: '',//费用金额
            Unit: '',//单位id
            UnitName: '',//单位名称
            PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: '',//备用字段1
            BString2: '',//备用字段2
            BString3: '',//备用字段3
            BString4: '',//备用字段4
            BString5: '',//备用字段5
            BaseNo: '',//商品编号(只显示)
            Standards: '',//规格(只显示)
            Model: '',//型号(只显示)
            id: '',//产地(只显示)
        },

    ],
    // 一条table数据
    emptyData: {
        PtypeId: '',//商品Id
        AtypeId: "",
        FullName: '',//商品名称
        BaseCode: "",
        Qty: '',//数量
        AQty: "",//可用库存
        ShowPrice: '',//单价
        Total: '',//金额
        Memo: '',//备注
        Discount: '',//折扣
        DiscountPrice: '',//折后单价
        DiscountTotal: '',//折后金额
        Tax: '',//税率
        TaxPrice: '',//产品含税单价
        WithTaxTotal: '',//产品含税金额
        TaxTotal: '',//税额
        ChargePrice: '',//费用单价
        ChargeTotal: '',//费用金额
        Unit: '',//单位id
        UnitName: '',//单位名称
        PStutas: '',//销售单才传值,赠品标记,1-赠品,0-非赠品
        BString1: '',//备用字段1
        BString2: '',//备用字段2
        BString3: '',//备用字段3
        BString4: '',//备用字段4
        BString5: '',//备用字段5
        BaseNo: '',//商品编号(只显示)
        Standards: '',//规格(只显示)
        Model: '',//型号(只显示)
        id: '',//产地(只显示)
    },
    // 单据表格表头配置站位防止样式乱
    tableHead: [
        {
            "BaseNo": 172,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "FullName",
            "Name": "商品名称",
            "Rename": "商品名称",
            "No": 1,
            "ReNo": 1,
            "InText": "",
            "FillType": 1,
            "Width": "",
            "Show": true,
            "Must": true,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 171,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BaseCode",
            "Name": "商品编号",
            "Rename": "商品编号",
            "No": 2,
            "ReNo": 2,
            "InText": "",
            "FillType": 6,
            "Width": "",
            "Show": true,
            "Must": true,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 173,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Standards",
            "Name": "规格",
            "Rename": "规格",
            "No": 3,
            "ReNo": 3,
            "InText": "",
            "FillType": 6,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 174,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Model",
            "Name": "型号",
            "Rename": "型号",
            "No": 4,
            "ReNo": 4,
            "InText": "",
            "FillType": 6,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 175,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "id",
            "Name": "产地",
            "Rename": "产地",
            "No": 5,
            "ReNo": 5,
            "InText": "",
            "FillType": 6,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 176,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "UnitName",
            "Name": "单位",
            "Rename": "单位",
            "No": 6,
            "ReNo": 6,
            "InText": "",
            "FillType": 1,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 177,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "AQty",
            "Name": "可用库存",
            "Rename": "可用库存",
            "No": 7,
            "ReNo": 7,
            "InText": "",
            "FillType": 1,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 178,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Qty",
            "Name": "数量",
            "Rename": "数量",
            "No": 8,
            "ReNo": 8,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 179,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "ShowPrice",
            "Name": "单价",
            "Rename": "单价",
            "No": 9,
            "ReNo": 9,
            "InText": "",
            "FillType": 1,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 180,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Total",
            "Name": "金额",
            "Rename": "金额",
            "No": 10,
            "ReNo": 10,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 181,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Tax",
            "Name": "税率",
            "Rename": "税率",
            "No": 11,
            "ReNo": 11,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": false,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 182,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "TaxPrice",
            "Name": "含税单价",
            "Rename": "含税单价",
            "No": 12,
            "ReNo": 12,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": false,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 183,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "WithTaxTotal",
            "Name": "价税合计",
            "Rename": "价税合计",
            "No": 13,
            "ReNo": 13,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": false,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 184,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "TaxTotal",
            "Name": "税额",
            "Rename": "税额",
            "No": 14,
            "ReNo": 14,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": false,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 185,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Discount",
            "Name": "折扣",
            "Rename": "折扣",
            "No": 15,
            "ReNo": 15,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 186,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "DiscountPrice",
            "Name": "折后单价",
            "Rename": "折后单价",
            "No": 16,
            "ReNo": 16,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 187,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "DiscountTotal",
            "Name": "折后金额",
            "Rename": "折后金额",
            "No": 17,
            "ReNo": 17,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 188,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BarCode",
            "Name": "商品条码",
            "Rename": "商品条码",
            "No": 20,
            "ReNo": 20,
            "InText": "",
            "FillType": 1,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 189,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "PStutas",
            "Name": "状态",
            "Rename": "状态",
            "No": 21,
            "ReNo": 21,
            "InText": "",
            "FillType": 7,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 190,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "Memo",
            "Name": "备注",
            "Rename": "备注",
            "No": 22,
            "ReNo": 22,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 191,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BString1",
            "Name": "备用字段1",
            "Rename": "备用字段1",
            "No": 23,
            "ReNo": 23,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 192,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BString2",
            "Name": "备用字段2",
            "Rename": "备用字段2",
            "No": 24,
            "ReNo": 24,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 193,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BString3",
            "Name": "备用字段3",
            "Rename": "备用字段3",
            "No": 25,
            "ReNo": 25,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 194,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BString4",
            "Name": "备用字段4",
            "Rename": "备用字段4",
            "No": 26,
            "ReNo": 26,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
        {
            "BaseNo": 195,
            "Model": "SaleOrder",
            "Type": 2,
            "Key": "BString5",
            "Name": "备用字段5",
            "Rename": "备用字段5",
            "No": 27,
            "ReNo": 27,
            "InText": "",
            "FillType": 2,
            "Width": "",
            "Show": true,
            "Must": false,
            "Customize": "",
            "UpdateTime": "0000-00-00 00:00:00",
            "Customize1": "1"
        },
    ],
    // 下拉框数据
    maleData: [
        { lable: '全部单据', id: 0 },
        { lable: '销售订单', id: 8 },
        { lable: '销售出库单', id: 11 },
        { lable: '销售换货单', id: 142 },
        { lable: '销售退货', id: 45 },
        { lable: '采购订单', id: 7 },
        { lable: '采购入库单', id: 34 },
        { lable: '采购退货', id: 6 },
        { lable: '收款单', id: 4 },
        { lable: '付款单', id: 66 },
        { lable: '增加应收', id: 116 },
        { lable: '减少应收', id: 115 },
        { lable: '增加应付', id: 128 },
        { lable: '减少应付', id: 129 },
        { lable: '一般收入单', id: 93 },
        { lable: '一般费用单', id: 36 },
        { lable: '现金费用单', id: 35 },
        { lable: '资金流向单', id: 77 },
        { lable: '调拨出库单', id: 21 },
        { lable: '调拨入库单', id: 22 },
        { lable: '其他入库单', id: 126 },
        { lable: '其他出库单', id: 139 },
        { lable: '成本调价单', id: 57 },
        { lable: '报损单', id: 9 },
        { lable: '报溢单', id: 14 },
    ],
    // 页面路由信息数据
    pageList: [
        { pageName: '销售订单', pageRoute: 'saleorder', VchType: 8 },
        { pageName: '销售出库单', pageRoute: 'salesrelease', VchType: 11 },
        { pageName: '销售退货单', pageRoute: 'salereturn', VchType: 45 },
        { pageName: '销售换货单', pageRoute: 'saleexchange', VchType: 142 },
        { pageName: '采购订单', pageRoute: 'procurementorder', VchType: 7 },
        { pageName: '采购入库单', pageRoute: 'procurementsrelease', VchType: 34 },
        { pageName: '采购退货单', pageRoute: 'procurementreturn', VchType: 6 },
        { pageName: '其他入库单', pageRoute: 'otherreceipt', VchType: 126 },
        { pageName: '其他出库单', pageRoute: 'outofstock', VchType: 139 },
        { pageName: '报损单', pageRoute: 'reportloss', VchType: 9 },
        { pageName: '报溢单', pageRoute: 'newspaper', VchType: 14 },
        { pageName: '调拨出库单', pageRoute: 'transfer', VchType: 21 },
        { pageName: '调拨入库单', pageRoute: 'transferlaid', VchType: 22 },
        { pageName: '调价单', pageRoute: 'modifyprice', VchType: 57 },
        { pageName: '收款单', pageRoute: 'voucherorder', VchType: 4 },
        { pageName: '付款单', pageRoute: 'paymentorder', VchType: 66 },
        { pageName: '增加应收', pageRoute: 'increaseaccounts', VchType: 116 },
        { pageName: '减少应收', pageRoute: 'reduceaccounts', VchType: 115 },
        { pageName: '增加应付', pageRoute: 'increasedcope', VchType: 128 },
        { pageName: '减少应收', pageRoute: 'reducecope', VchType: 129 },
        { pageName: '一般收入单', pageRoute: 'generalrevenue', VchType: 93 },
        { pageName: '一般费用单', pageRoute: 'generalcost', VchType: 36 },
        { pageName: '现金费用单', pageRoute: 'cashstatement', VchType: 35 },
        { pageName: '资金流向单', pageRoute: 'moneyflows', VchType: 77 },
    ],
    // 客户选择显示字段数据
    CustomConfig: [
        { label: '分类', Key: 'IsDir' },
        { Label: '名称', Key: 'FullName' },
        { Label: '编号', Key: 'BaseCode' },
        { Label: '助记码', Key: 'PyNo' },
        { Label: '所属分类', Key: 'ParentNos' },
        { Label: '单位电话', Key: 'UnitPhone' },
        { Label: '单位地址', Key: 'Address' },
        { Label: '传真号码', Key: 'FaxNum' },
        { Label: '联系人', Key: 'LinkMan' },
        { Label: '联系电话', Key: 'LinkPhone' },
        { Label: '默认经手人', Key: 'PersonName' },
        { Label: '电子邮箱', Key: 'Email' },
        { Label: '单位邮编', Key: 'PostCode' },
        { Label: '微信号', Key: 'WeChatId' },
        { Label: '开户账号', Key: 'BankAndAcount' },
        { Label: '单位税号', Key: 'TaxNum' },
        { Label: '备注', Key: 'Memo' },
        { Label: '应收上限', Key: 'ARLimit' },
        { Label: '应付上限', Key: 'APLimit' },
        { Label: '收款期限', Key: 'SkLimit' },
        { Label: '价格选择', Key: 'DeftPriceA' },
        { Label: '换货比例', Key: 'ChgGoodScale' },
        { Label: '默认折扣', Key: 'Discount' },
    ],
    // 仓库选择显示字段数据
    WarehouseConfig: [
        { label: '分类', Key: 'IsDir' },
        { Label: '名称', Key: 'FullName' },
        { Label: '编号', Key: 'BaseCode' },
        { Label: '助记码', Key: 'PyNo' },
        { Label: '仓库分类', Key: 'StType' },
        { Label: '备注', Key: 'Memo' },
    ],
    // 经手人选择显示字段数据
    HandlersConfig: [
        { label: '分类', Key: 'IsDir' },
        { Label: '职员名称', Key: 'FullName' },
        { Label: '职员编号', Key: 'BaseCode' },
        { Label: '助记码', Key: 'PyNo' },
        // {Label:'职员分类',Key:'BaseCode'},
        { Label: '生日', Key: 'Birthday' },
        { Label: '入职时间', Key: 'InJobDate' },
        { Label: '联系电话', Key: 'LinkTel' },
        { Label: '所在部门', Key: 'DeptId' },
        { Label: '移动电话', Key: 'HandTel' },
        { Label: '文化程度', Key: 'EducateLevel' },
        { Label: '身份证号', Key: 'IDCard' },
        { Label: '职务', Key: 'Incumbency' },
        // {Label:'默认仓库',Key:'BaseCode'},
        { Label: '是否能更改仓库', Key: 'ChangeKType' },
        // {Label:'每单优惠限额',Key:'BaseCode'},
        // {Label:'状态',Key:'BaseCode'},
        { Label: '备注', Key: 'Memo' },
    ],
    // 部门选择显示字段数据
    DepartmentConfig: [
        { label: '分类', Key: 'IsDir' },
        { Label: '部门名称', Key: 'FullName' },
        { Label: '部门编号', Key: 'BaseCode' },
        { Label: '助记码', Key: 'PyNo' },
        // {Label:'每单优惠限额',Key:'BaseCode'},
        // {Label:'状态',Key:'BaseCode'},
        { Label: '备注', Key: 'Memo' },
    ],
    // 地区选择显示字段数据
    AreaConfig: [
        { label: '分类', Key: 'IsDir' },
        { Label: '名称', Key: 'FullName' },
        { Label: '编号', Key: 'BaseCode' },
        { Label: '助记码', Key: 'PyNo' },
        { Label: '地区分类', Key: 'ParentNos' },
        { Label: '状态', Key: 'StopedName' },
        { Label: '备注', Key: 'Memo' },
    ],
    // 地区选择显示字段数据
    BankConfig: [
        { label: '分类', Key: 'IsDir' },
        { label: '科目名称', Key: 'FullName' },
        { label: '科目编码', Key: 'UserCode' },
        { label: '助记码', Key: 'PyNo' },
        // {label:'状态',Key:'Stoped'},
        { label: '备注', Key: 'Memo' },
    ],
    // 商品表格数据(单单位)
    goodsTableData1:[
        {
            Unit:0,//商品单位id
            UnitId:1,//商品单位顺序1,2,3,4（对应基础单位，辅助单位1，辅助单位2，辅助单位3）
            Percent:'1',//换算率
            CID:'',//颜色ID
            SID:'',//尺码ID
            FID:'',//厂商ID
            BarCode:'',//商品单位对应条形码
            SalePrice:'',//零售价
            LSalePrice:'',//最低售价
            WholesalePrice:'',//批发价
            BuyPrice:'',//预设进价
            PriceOne:'',//预设售价1
            PriceTwo:'',//预设售价2
            PriceThree:'',//预设售价3
            PriceFour:'',//预设售价4
            Choose:1,//0未默认 1默认（4个单位必须默认1个）
        }
    ],
    // 商品表格数据(多单位)
    goodsTableData2:[
        // {
        //     Unit:0,//商品单位id
        //     UnitId:1,//商品单位顺序1,2,3,4（对应基础单位，辅助单位1，辅助单位2，辅助单位3）
        //     Percent:'1',//换算率
        //     CID:'',//颜色ID
        //     SID:'',//尺码ID
        //     FID:'',//厂商ID
        //     BarCode:'',//商品单位对应条形码
        //     SalePrice:'',//零售价
        //     LSalePrice:'',//最低售价
        //     WholesalePrice:'',//批发价
        //     BuyPrice:'',//预设进价
        //     PriceOne:'',//预设售价1
        //     PriceTwo:'',//预设售价2
        //     PriceThree:'',//预设售价3
        //     PriceFour:'',//预设售价4
        //     Choose:1,//0未默认 1默认（4个单位必须默认1个）
        // },
        {
            Unit:0,//商品单位id
            UnitId:2,//商品单位顺序1,2,3,4（对应基础单位，辅助单位1，辅助单位2，辅助单位3）
            Percent:'',//换算率
            CID:'',//颜色ID
            SID:'',//尺码ID
            FID:'',//厂商ID
            BarCode:'',//商品单位对应条形码
            SalePrice:'',//零售价
            LSalePrice:'',//最低售价
            WholesalePrice:'',//批发价
            BuyPrice:'',//预设进价
            PriceOne:'',//预设售价1
            PriceTwo:'',//预设售价2
            PriceThree:'',//预设售价3
            PriceFour:'',//预设售价4
            Choose:0,//0未默认 1默认（4个单位必须默认1个）
        },
        {
            Unit:0,//商品单位id
            UnitId:3,//商品单位顺序1,2,3,4（对应基础单位，辅助单位1，辅助单位2，辅助单位3）
            Percent:'',//换算率
            CID:'',//颜色ID
            SID:'',//尺码ID
            FID:'',//厂商ID
            BarCode:'',//商品单位对应条形码
            SalePrice:'',//零售价
            LSalePrice:'',//最低售价
            WholesalePrice:'',//批发价
            BuyPrice:'',//预设进价
            PriceOne:'',//预设售价1
            PriceTwo:'',//预设售价2
            PriceThree:'',//预设售价3
            PriceFour:'',//预设售价4
            Choose:0,//0未默认 1默认（4个单位必须默认1个）
        },
        {
            Unit:0,//商品单位id
            UnitId:4,//商品单位顺序1,2,3,4（对应基础单位，辅助单位1，辅助单位2，辅助单位3）
            Percent:'',//换算率
            CID:'',//颜色ID
            SID:'',//尺码ID
            FID:'',//厂商ID
            BarCode:'',//商品单位对应条形码
            SalePrice:'',//零售价
            LSalePrice:'',//最低售价
            WholesalePrice:'',//批发价
            BuyPrice:'',//预设进价
            PriceOne:'',//预设售价1
            PriceTwo:'',//预设售价2
            PriceThree:'',//预设售价3
            PriceFour:'',//预设售价4
            Choose:0,//0未默认 1默认（4个单位必须默认1个）
        },
    ]
}


// WEBPACK FOOTER //
// ./src/utils/data.js